import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Layout, Spin } from 'antd';
import AuthHeader from './header';
import AuthSider from './sider';
import AuthFooter from './footer';
import useAuth from '../../hooks/useAuth';
import { LoadingOutlined } from '@ant-design/icons';


const { Content } = Layout;


const ProtectedLayout = ({ children }: { children: JSX.Element }) => {
    let auth = useAuth();
    //let location = useLocation();

    if (auth?.hasToken === false) {
        return <Navigate to="/" 
            // state={{ from: location }} 
        />
    }

    return children;
}

const AuthLayout: React.FC = () => {

    const [logoutLoading, setLogoutLoading] = React.useState(false);

    const showLogoutLoading = () => {
        setLogoutLoading(true)
    }

    return (
        <ProtectedLayout>
            <Spin indicator={<LoadingOutlined style={{ fontSize: 100 }} />} spinning={logoutLoading}>
                <Layout hasSider>

                    {/* sider */}
                    <AuthSider />

                    <Layout className="site-layout">

                        {/* header */}
                        <AuthHeader showLogoutLoading={showLogoutLoading} />

                        {/* content */}
                        <Content
                            className="site-layout-background"
                            style={{
                                padding: 24,
                                margin: 0,
                                height: '100%',
                            }}
                        >
                            <Outlet />
                        </Content>

                        {/* footer */}
                        <AuthFooter />                                                                    
                        
                    </Layout>

                </Layout>
            </Spin>

        </ProtectedLayout>

    )
}

export default AuthLayout;